import type { AuditColumnKey } from "@/modules/audit";

/** Chaves dos filtros da aba, no formato do `FilterValue`. */
export const AUDIT_YEAR_KEY = "ano";
export const AUDIT_ACTION_KEY = "alteracao";
export const AUDIT_MODULE_KEY = "modulo";
export const AUDIT_RESPONSAVEL_KEY = "responsavel";

/** Anos oferecidos no filtro Ano: o corrente e os anteriores. */
export const AUDIT_YEARS_BACK = 4;

export const AUDIT_FILTER_LABELS = {
  [AUDIT_YEAR_KEY]: "Ano",
  [AUDIT_ACTION_KEY]: "Alteração",
  [AUDIT_MODULE_KEY]: "Módulo",
  [AUDIT_RESPONSAVEL_KEY]: "Responsável",
} as const;

export const AUDIT_EXPORT_FILE_NAME = "auditoria";
export const AUDIT_EXPORT_LIST_NAME = "registros de auditoria";

export const AUDIT_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar os registros de auditoria do Hub.";
export const AUDIT_ERROR_MESSAGE = "Não foi possível carregar os registros de auditoria.";

export const AUDIT_DETAIL_SESSION_EXPIRED_MESSAGE =
  "Sua sessão expirou. Entre novamente para consultar os detalhes da auditoria.";
export const AUDIT_DETAIL_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar este registro de auditoria.";
export const AUDIT_DETAIL_NOT_FOUND_MESSAGE = "Registro de auditoria não encontrado.";
export const AUDIT_DETAIL_ERROR_MESSAGE = "Não foi possível carregar os detalhes da auditoria.";

/** Substantivo do vazio: "registro" sem filtro; com filtro, "Nenhuma auditoria corresponde…" (Figma 7393:142201). */
export const AUDIT_EMPTY_NO_RECORDS = {
  noun: "registro",
  gender: "m",
  plural: "registros",
} as const;
export const AUDIT_EMPTY_FILTERED = {
  noun: "auditoria",
  gender: "f",
  plural: "auditorias",
} as const;

export const AUDIT_LOADING_LABEL = "Carregando registros de auditoria...";
export const AUDIT_ROWS_PER_PAGE_LABEL = "Registros por página";
export const AUDIT_TABLE_LABEL = "Registros de auditoria";

export type { AuditColumnKey };

export const AUDIT_ACTIONS_KEY = "acoes";
export const AUDIT_ACTIONS_HEADER = "Ações";
export const AUDIT_ACTIONS_WIDTH = "3rem";

/** Colunas de dado do Figma 4407:581544, na ordem da tabela; a Justificativa toma o resto da largura. */
export const AUDIT_COLUMNS = [
  { key: "dataHora", header: "Data/Hora", width: "6.875rem" },
  { key: "acao", header: "Ação", width: "17.875rem" },
  { key: "justificativa", header: "Justificativa", width: undefined },
  { key: "modulo", header: "Módulo", width: "7.75rem" },
  { key: "responsavel", header: "Responsável", width: "8.75rem" },
] as const;

/** Todas as colunas, na ordem da tabela: com 6 ou menos a seção de colunas do Configurações da Tabela não aparece. */
export const AUDIT_ALL_COLUMNS: readonly AuditColumnKey[] = [
  ...AUDIT_COLUMNS.map(({ key }) => key),
  AUDIT_ACTIONS_KEY,
];

/** Abaixo disso a tabela rola na horizontal em vez de espremer as colunas. */
export const AUDIT_TABLE_MIN_WIDTH = "57rem";

/** Usuário que o serviço registra quando a ação não tem pessoa por trás: sem cartão de contato. */
export const AUDIT_SYSTEM_USER = "system";
